import type { BasePluginOptions, RuntimeContext } from '@antv/g6'
import { BasePlugin, treeToGraphData } from '@antv/g6'
import data from '@/api/tree-data.json'
import { treeDataToGraphNodeData } from '../util'

interface RemoteDataSourceOptions extends BasePluginOptions {}

export class RemoteDataSource extends BasePlugin<RemoteDataSourceOptions> {
  constructor(context: RuntimeContext, options: RemoteDataSourceOptions) {
    super(context, options)
    this.loadData()
  }

  private async loadData() {
    const treeData = treeToGraphData(data, {
      getNodeData: treeDataToGraphNodeData,
    })

    // console.log('treeData', treeData)

    // mock remote data
    // const data = {
    //   nodes: [
    //     { id: 'node-1', x: 100, y: 100 },
    //     { id: 'node-2', x: 200, y: 200 },
    //   ],
    //   edges: [{ source: 'node-1', target: 'node-2' }],
    //   combos: [
    //     { id: '1-A', data: { groupName: 'Group A' } },
    //     { id: '1-B', data: { groupName: 'Group B' } },
    //     { id: '1-C', data: { groupName: 'Group C' } },
    //     { id: '1-D', data: { groupName: 'Group D' } },
    //   ],
    // }
    console.log('treeData', treeData)
    const { graph } = this.context
    graph.setData({
      ...treeData,
      combos: [
        { id: '1-A', data: { groupName: 'Group A' } },
        { id: '1-B', data: { groupName: 'Group B' } },
        { id: '1-C', data: { groupName: 'Group C' } },
        { id: '1-D', data: { groupName: 'Group D' } },
      ],
    })

    await graph.render()
  }
}
